import moment from 'moment';
import { FunctionComponent } from 'react';
import { toDefaultDateFormat } from 'utils/dateUtils';
import { Strikethrough, Subtle } from './styles';
import { Text } from '@montel/montelpro-shared-components-v2';

export const formatValue = (value: any): string => {
	if (!value) return '(empty)';

	if (typeof value === 'string' && moment(value).isValid()) {
		return toDefaultDateFormat(value);
	}

	if (Array.isArray(value)) {
		return value.length > 0 ? value.join(', ') : '(empty)';
	}

	return String(value);
};

export const DeltaValue: FunctionComponent<{
	from?: any;
	to?: any;
	label?: string;
}> = ({ from, to, label }) => {
	const fromFormatted = formatValue(from);
	const toFormatted = formatValue(to);

	if (fromFormatted === toFormatted) return null;

	return (
		<Text size="sm">
			{label && <Subtle>{label}: </Subtle>}
			<Strikethrough>{fromFormatted}</Strikethrough>
			{` → ${toFormatted}`}
		</Text>
	);
};
